import Column from '@components/Column';
import CtaLayout from '@components/CtaLayout';
import Divider from '@components/Divider';
import Header from '@components/Header';
import PrepaidCardNotes from '@components/prepaid/PrepaidCardNotes';
import TermNotes from '@components/term/TermNotes';
import useGiftItem from '@hooks/gift/useGiftItem';
import { GiftItemType } from '@models/gift';
import GiftOrderProvider from '@providers/GiftOrderProvider';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

import CardAmount from './components/CardAmount';
import CardInfo from './components/CardInfo';
import Complete from './components/Complete';
import Footer from './components/Footer';
import ItemInfo from './components/ItemInfo';
import Message from './components/Message';
import PaymentMethod from './components/PaymentMethod';
import Receiver from './components/Receiver';
import Sender from './components/Sender';
import SendMethod from './components/SendMethod';
import styles from './styles.module.scss';

interface Params {
    type: GiftItemType;
    giftItemId: string;
    qty: number;
    giftCardImageId?: string;
}

const GiftOrderActivity: ActivityComponentType<Params> = ({ params }:{params: Params}) => {
    const {
        type, giftItemId, qty, giftCardImageId,
    } = params;
    const isCard = type === 'CASH';
    const giftItem = useGiftItem(giftItemId);
    const { t } = useTranslation('gift');
    return (
        <AppScreen>
            <GiftOrderProvider>
                <form style={{ width: '100%', height: '100vh' }}>
                    {giftItem && (
                        <CtaLayout header={<Header title={t('giftOrder.title')}/>}
                            footer={<Footer type={type}
                                giftItem={giftItem}
                                qty={qty}
                                giftCardImageId={giftCardImageId} />} >
                            {isCard ? (<CardInfo giftCardImageId={giftCardImageId!}/>)
                                : (<ItemInfo giftItem={giftItem} qty={qty}/>)}
                            <Column className={styles.container}
                                fullWidth
                                spacing={38} >
                                <Message/>
                                <Sender/>
                                <SendMethod/>
                                <Receiver/>
                                {isCard && (<CardAmount amount={giftItem.salePrice}/>)}
                                {/* <PaymentMethod/> */}
                            </Column>
                            <Divider/>
                            <TermNotes displayContext='GIFT' />
                            <Complete/>
                        </CtaLayout>
                    )}
                </form>
            </GiftOrderProvider>
        </AppScreen>
    );
};

export default GiftOrderActivity;
